import { create } from "zustand"

interface ScreenLoadingStore {
    screenLoading: boolean
    setScreenLoading(screenLoading: boolean): void
}

const useScreenLoading = create<ScreenLoadingStore>(set => ({
    screenLoading: true,
    setScreenLoading: screenLoading => set({ screenLoading })
}))

export default useScreenLoading